<template lang='pug'>
  div(@click.prevent.stop='toggle')
    v-badge(color='accent'
      @click.prevent.stop='toggle'
      :content='badge'
      bottom
      left
      offset-x='20'
      offset-y='20'
      :dot='!value'
      :value='badge')
      v-tooltip(bottom)
        template(v-slot:activator='{on}')
          v-btn(v-on='on' @click.prevent.stop='toggle' text icon)
            v-icon filter_list
        span Show Filters
</template>

<script>
export default {
  name: 'FilterButton',
  props: {
    value: {
      required: true
    },
    badge: {
      type: Number,
      default() {
        return 0;
      }
    }
  },
  methods: {
    toggle() {
      this.$emit('input', !this.value);
    }
  }
};
</script>

<style lang='scss'>
</style>
